export default __webpack_public_path__ + "static/media/coffeeshop_2.03367a06.png";